import React, { ReactChild, useContext, useEffect } from 'react'
import styled from 'styled-components'
import { Column, Grid, Row } from '@jarvis.oddle/core/components/Grid'
import Card from '@jarvis.oddle/core/components/Card'
import Flex from '@jarvis.oddle/core/components/Flex'
import Form from '@jarvis.oddle/core/components/Form'
import { H1 } from '@jarvis.oddle/core/components/Typo'
import { marginSizes } from '@jarvis.oddle/core/theme/default'
import { redirect } from 'src/utils/routes'
import { useRouter } from 'next/router'
import IconOddlePass from '@jarvis.oddle/core/components/Icons/IconOddlePass'
import UserContext from 'src/containers/UserContext'
import UserPagesNavigation, {
  pages
} from 'src/components/molecules/UserPagesNavigation'
import { TabletOnly } from 'src/components/core/Responsive'
import ResponsiveSection from 'src/components/core/ResponsiveSection'

export const UserPageButton = styled(Form.SubmitButton)`
  width: 300px;
  max-width: 100%;
`

export const UserPageButtonsContainer = styled(Flex).attrs(() => ({
  marginTop: marginSizes.medium,
  marginBottom: marginSizes.medium,
  flexDirection: 'column',
  alignItems: 'center'
}))``

const StyledIconOddlePass = styled(IconOddlePass).attrs((props) => ({
  fill: props.theme.colorSectionHeadingsFont
}))``

interface UserPageProps {
  currentPage: string
  title: string
  children: ReactChild | ReactChild[]
}

export const UserPage = ({
  currentPage,
  title,
  children
}: UserPageProps): JSX.Element => {
  const router = useRouter()
  const {
    isUserLoggedIn,
    isUserInfoFetched,
    isOddlePassEnabled,
    isLoginFailed
  } = useContext(UserContext)

  useEffect(() => {
    //  if we rely on !isUserLoggedIn && !isUserInfoFetched is not enough, because when we access page user.data it give us empty object first that causes isUserLoggedIn return false and redirect to landing page
    // when useEffect do re-fetch again we can get actual value from !isUserLoggedIn, so the proper way to decide user has logged in or not we add isLoginFailed.
    if (isLoginFailed && !isUserLoggedIn && !isUserInfoFetched) {
      redirect({
        url: '/[locale]',
        as: `/${router.query.locale}`,
        shallow: true
      })
    }
  }, [router, isUserInfoFetched, isLoginFailed, isUserLoggedIn])

  if (!isUserLoggedIn) return null

  return (
    <ResponsiveSection>
      <ResponsiveSection.Container>
        <Grid>
          <Row>
            <Column smHidden mdHidden lg={3}>
              <UserPagesNavigation currentPage={currentPage} />
            </Column>
            <Column sm={12} md={12} lg={9}>
              <Flex
                justifyContent='space-between'
                alignItems='center'
                marginBottom={marginSizes.medium}
              >
                <H1 normalised sectionHeading>
                  {title}
                </H1>
                {currentPage === pages['accountDetails'] && isOddlePassEnabled && (
                  <TabletOnly>
                    <StyledIconOddlePass />
                  </TabletOnly>
                )}
              </Flex>
              <Card>{children}</Card>
            </Column>
          </Row>
        </Grid>
      </ResponsiveSection.Container>
    </ResponsiveSection>
  )
}

export default UserPage
